import Stimulus from "./helpers/stimulus";
import commonControllers from "./controllers/common/index";
import marketingControllers from "./controllers/marketing/index";

Stimulus.start();
[...commonControllers, ...marketingControllers].forEach((controller: { name: string; module: { default: any } }) => {
  Stimulus.register(controller.name, controller.module.default);
});
